module.exports = __webpack_public_path__ + "media/bin-card/icoAi-c34a888a.png";